<template>
  <div class="preview">
    <figure 
      class="image">
      <img :src="galleryPreview['sizes']['gallery-thumb']">
      <figcaption class="caption" v-html="gallery.gallery_name"></figcaption>
    </figure>
  </div>
</template>

<script>
export default {
  props: {
    gallery: Object
  },
  computed: {
    galleryPreview () {
      if (this.gallery && this.gallery.images) return this.gallery.images[0]
    }
  }
}
</script>

<style scoped lang="scss">
.preview {
  position: relative;
  .image {
    img {
      max-width: 100%;
      height: auto;
    }
    &:first-child {
      position: relative;
    }
    &:not(:first-child) {
      position: absolute;
      top: 0;
      left: 0;
    }
    &:nth-child(2) {
      top: 4px;
      left: 4px;
    }
  }
  .caption {
    font-weight: bold;
    font-size: 1.1rem;
  }
}
</style>



// WEBPACK FOOTER //
// GalleryThumb.vue?2cd20539